import { CalculationResultValues } from '../../components/Solutions/types';
import { LoadingType } from '../filter/interfaces';

export enum SolutionsValueKey {
  INPUT_PRESSURE = 'inputPressure',
  OUTPUT_PRESSURE = 'outputPressure',
  FLOWRATE = 'flowrate',
  FLOWRATE_PER_HOUR = 'flowratePerHour',
  PRESSURE_TYPE_TK = 'pressureTypeTranslationKey',
}

export interface SolutionResponseProps {
  inputPressure?: number;
  outputPressure?: number;
  flowrate?: number;
  flowratePerHour?: number;
  pressureTypeTranslationKey?: string;
}
export interface SolutionRequestProps {
  calculationType: CalculationResultValues;
  inputPressure: number;
  outputPressure: number;
  tubingLength: number;
  internalDiameter: number;
  flowrate: number;
}

export interface ResultsSliceState {
  isResultsLoading: LoadingType;
  solution: SolutionResponseProps | null;
}
